import { LDUser } from 'launchdarkly-js-client-sdk';
import { useCurrentUser } from './use-current-user.hook';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { configSelector } from 'store/config/selectors';
import { selectBuilding } from 'store/building/selectors';
import { VERTICAL_NAME } from 'shared/consts';

interface WebTrackingData {
  currentUser: LDUser;
  buildingUuid: string;
  appUuid: string;
  clientApiUrl: string;
  authToken: string;
}

export const useWebTrackingAnalytics = (): WebTrackingData | null => {
  const building = useSelector(selectBuilding);
  const [user] = useCurrentUser();
  const { apiUrl: clientApiUrl, authToken } = useSelector(configSelector);

  return useMemo(() => {
    if (!building || !user) {
      return null;
    }
    return {
      currentUser: { key: user.uuid, email: user.email },
      buildingUuid: building.uuid,
      appUuid: VERTICAL_NAME,
      clientApiUrl,
      authToken,
    };
  }, [building, user, clientApiUrl, authToken]);
};
